import React from 'react';
import '../styles/global.scss';
import Layout from '../components/Layout/Layout';
var Work = function Work() { return /*#__PURE__*/ React.createElement(React.Fragment, null, "Work History Page"); };
Work.Layout = Layout;
export default Work;
